import { isNil } from "@kalodata/tools";

export const parseCateValue = () => {
  const url = new URL(window.location.href);
  let cateValue = null;
  try {
    let cateValueString = url.searchParams.get("cateValue");
    if (cateValueString) {
      cateValue = JSON.parse(cateValueString);
    }
  } catch (err) {}
  return cateValue;
};

export const parseCateId = () => {
  const url = new URL(window.location.href);
  let cateValue = null;
  try {
    let cateValueString = url.searchParams.get("id");
    if (cateValueString) {
      cateValue = JSON.parse(cateValueString);
    }
  } catch (err) {}
  return cateValue;
};

export const parseDateRange = () => {
  const url = new URL(window.location.href);
  let dateRange = null;
  try {
    let dateRangeString = url.searchParams.get("dateRange");
    if (dateRangeString) {
      const dateRangeArray = JSON.parse(dateRangeString);
      if (dateRangeArray && dateRangeArray.length === 2) {
        dateRange = dateRangeArray;
      }
    }
  } catch (err) {}
  return dateRange;
};

export const parseSeniorFilterValue = () => {
  const url = new URL(window.location.href);
  let filterValue = null;
  try {
    let filterValueString = url.searchParams.get("filterValue");
    if (filterValueString) {
      filterValue = JSON.parse(filterValueString);
    }
  } catch (err) {}
  return filterValue;
};

export const parseSorterValue = () => {
  const url = new URL(window.location.href);
  let sorterValue = null;
  try {
    let sorterValueString = url.searchParams.get("sorterValue");
    if (sorterValueString) {
      sorterValue = JSON.parse(sorterValueString);
    }
  } catch (err) {}
  return sorterValue;
};

export const parseParam = (key: string) => {
  const url = new URL(window.location.href);
  return url.searchParams.get(key);
};

export const toURLParams = (params: any) => {
  let urlSearchParams = new URLSearchParams();
  Object.keys(params).map((key) => {
    let value = params[key];
    if (value !== undefined && value !== null) {
      urlSearchParams.append(key, value);
    }
  });
  return urlSearchParams.toString();
};

interface UrlParamItem {
  key: string;
  value?: string | null;
}

/**
 * 为 URL 追加查询参数
 * @param url 原始 URL
 * @param params 参数列表
 */
export const appendUrlParams = (url: string, params: UrlParamItem[]): string => {
  if (!url) return url;
  let finalUrl = url;

  params.forEach(({ key, value }) => {
    if (!key || isNil(value) || value === "") {
      return;
    }
    const hasParam = new RegExp(`([?&])${key}=`).test(finalUrl);
    if (hasParam) {
      return;
    }
    const separator = finalUrl.includes("?") ? "&" : "?";
    finalUrl = `${finalUrl}${separator}${key}=${encodeURIComponent(value)}`;
  });

  return finalUrl;
};
